/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1AuthExchangeRequest,
    V1AuthExchangeRequestFromJSON,
    V1AuthExchangeRequestToJSON
} from '../models/V1AuthExchangeRequest'
import {
    type V1AuthMePayload,
    V1AuthMePayloadFromJSON,
    V1AuthMePayloadToJSON
} from '../models/V1AuthMePayload'
import {
    type V1AuthTokenResponse,
    V1AuthTokenResponseFromJSON,
    V1AuthTokenResponseToJSON
} from '../models/V1AuthTokenResponse'
import {
    type V1AuthUpdatePayload,
    V1AuthUpdatePayloadFromJSON,
    V1AuthUpdatePayloadToJSON
} from '../models/V1AuthUpdatePayload'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'

export interface ExchangeRequest {
    /**
     *
     */
    v1AuthExchangeRequest: V1AuthExchangeRequest
}

export interface UpdateRequest {
    /**
     *
     */
    v1AuthUpdatePayload: V1AuthUpdatePayload
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
    /**
     * Creates request options for exchange without sending the request
     */
    async exchangeRequestOpts(
        requestParameters: ExchangeRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1AuthExchangeRequest'] == null) {
            throw new runtime.RequiredError(
                'v1AuthExchangeRequest',
                'Required parameter "v1AuthExchangeRequest" was null or undefined when calling exchange().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        let urlPath = `/api/v1/auth/exchange`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1AuthExchangeRequestToJSON(
                requestParameters['v1AuthExchangeRequest']
            )
        }
    }

    /**
     * Exchange user credentials for a JWT token
     */
    async exchangeRaw(
        requestParameters: ExchangeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1AuthTokenResponse>> {
        const requestOptions = await this.exchangeRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1AuthTokenResponseFromJSON(jsonValue)
        )
    }

    /**
     * Exchange user credentials for a JWT token
     */
    async exchange(
        requestParameters: ExchangeRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1AuthTokenResponse> {
        const response = await this.exchangeRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for me without sending the request
     */
    async meRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/auth/me`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Get the authenticated user profile
     */
    async meRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1AuthMePayload>> {
        const requestOptions = await this.meRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1AuthMePayloadFromJSON(jsonValue)
        )
    }

    /**
     * Get the authenticated user profile
     */
    async me(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1AuthMePayload> {
        const response = await this.meRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for update without sending the request
     */
    async updateRequestOpts(
        requestParameters: UpdateRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1AuthUpdatePayload'] == null) {
            throw new runtime.RequiredError(
                'v1AuthUpdatePayload',
                'Required parameter "v1AuthUpdatePayload" was null or undefined when calling update().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/auth/update`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1AuthUpdatePayloadToJSON(
                requestParameters['v1AuthUpdatePayload']
            )
        }
    }

    /**
     * Partial update: only the fields sent change. Consents are set once.
     * Update user profile information
     */
    async updateRaw(
        requestParameters: UpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1AuthTokenResponse>> {
        const requestOptions = await this.updateRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1AuthTokenResponseFromJSON(jsonValue)
        )
    }

    /**
     * Partial update: only the fields sent change. Consents are set once.
     * Update user profile information
     */
    async update(
        requestParameters: UpdateRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1AuthTokenResponse> {
        const response = await this.updateRaw(requestParameters, initOverrides)
        return await response.value()
    }
}
